// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-feature-review__container[data-v-78924596]{padding:24px;background-color:#2C1A48;border-radius:8px}.card-feature-review__content[data-v-78924596]{display:flex;flex-direction:column;gap:16px}.card-feature-review__heading[data-v-78924596]{display:flex;flex-direction:row;gap:16px}.card-feature-review__image[data-v-78924596]{width:40px;height:40px}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
